import axiosInstance from '../../../axiosInstance';
import { jwtDecode } from 'jwt-decode';

export const login = async (credentials) => {
  try {
    const response = await axiosInstance.post('/api/auth/login/superAdmin', credentials, { withCredentials: true });
    return response.status === 200;
  } catch (error) {
    console.log('Login failed:', error);
    return false;
  }
};

export const logout = async () => {
  // localStorage.clear();

  try {
    const response = await axiosInstance.get('/api/auth/logout');
    if (response.status === 200) {
      window.location.href = '/login';
    }
  } catch (error) {
    console.log('Login failed:', error);
    return false;
  }
};

// # TODO: Validate function
// export const getToken = () => {
//   return localStorage.getItem('token');
// };

export const getCurrentUser = async () => {
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/superAdmins/me`, { withCredentials: true });
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const checkUser = async () => {
  console.log('Checking login status...');
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/auth/check`, { withCredentials: true });
    if (response.status === 200) {
      console.log('id:', response.data.id);
      return response.data.id;
    } else {
      console.log('id: NUlL');
      return null;
    }
  } catch (error) {
    console.log('Auth check failed:', error);
    return null;
  }
};

export const isAuthenticated = async () => {
  try {
    const check = await checkUser();
    if (check === null) {
      // console.log('User is not authenticated');
      return false;
    } else {
      // console.log('User is authenticated');
      // console.log(check, 'user id');
      return true;
    }
  } catch (error) {
    console.log("Error during authentication check:", error);
    return false;
  }
};

const isTokenExpired = (token) => {
  const decodedToken = jwtDecode(token);
  return decodedToken.exp * 1000 < Date.now();
};